import { render, staticRenderFns } from "./PinBoard.vue?vue&type=template&id=25b88750&"
import script from "./PinBoard.vue?vue&type=script&lang=js&"
export * from "./PinBoard.vue?vue&type=script&lang=js&"
import style0 from "./PinBoard.vue?vue&type=style&index=0&id=25b88750&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports